// @flow
import React from 'react';
import type { ContextRouter } from 'react-router-dom';
import BackboneWrapper from './BackboneWrapper';
import type { BackboneBaseView } from './BackboneWrapper';

/**
 * This was lifted directly from the old mainapp core router. It should be left as-is as the
 * Backbone views are likely to depend on idiosyncrasies particular to it.
 */
function parseQueryString(queryStr: string): { [string]: string } {
  const queryValues = {};
  queryStr.replace(
    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
    // $FlowFixMe - original code intentionally misusing replace here
    ($0, $1, $2, $3) => {
      queryValues[$1] = $3;
    },
  );
  return queryValues;
}

/**
 * Returns a `<Route render={...} />`-function which will mount the given backbone view and set
 * the given title.
 */
// eslint-disable-next-line react/prop-types
export default (documentTitle: string, backboneView: Class<BackboneBaseView>) =>
  // eslint-disable-next-line react/display-name
  ({ match, location: { state, search } }: ContextRouter) => {
    const pathParams = match.params.pathParams ? match.params.pathParams.split('/') : [];
    document.title = documentTitle;
    return (
      <BackboneWrapper
        view={backboneView}
        pathParams={pathParams}
        queryVals={parseQueryString(search)}
        reloadMarker={state ? state.reloadMarker : 0}
      />
    );
  };
